export default __webpack_public_path__ + "static/media/splashScreenSX1_dark.9432b5c8.webm";